import { IconButton, Tooltip, Badge, Typography, Box } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import React from "react";

type NavIconButtonProps = {
    to: string;
    tooltip: string;
    icon: React.ReactNode;
    text: string;
    badgeContent?: number;
    hideBadgeWhenZero?: boolean;
    ariaLabel: string;
};

export default function NavIconButton(props: NavIconButtonProps) {
    const { to, tooltip, icon, text, badgeContent, hideBadgeWhenZero = true, ariaLabel } = props;

    const location = useLocation();
    const isActive = location.pathname.includes(to);

    const buttonContent = (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                color: isActive ? "var(--primary-color)" : "var(--text-secondary-color)",
                textDecoration: "none",
                "&:hover": {
                    color: "var(--primary-color)",
                    "& .MuiTypography-root": {
                        color: "var(--primary-color)",
                    },
                    "& .MuiSvgIcon-root": {
                        color: "var(--primary-color)",
                    },
                },
                cursor: "pointer",
            }}
            component={Link}
            to={to}
            aria-label={ariaLabel}
        >
            <IconButton
                size="small"
                sx={{
                    padding: "4px",
                    color: "inherit",
                }}
            >
                {badgeContent !== undefined ? (
                    <Badge
                        badgeContent={badgeContent}
                        color="error"
                        invisible={hideBadgeWhenZero && badgeContent === 0}
                    >
                        {icon}
                    </Badge>
                ) : (
                    icon
                )}
            </IconButton>
            <Typography variant="caption" sx={{ lineHeight: "1.2", mt: "2px", color: "inherit" }}>
                {text}
            </Typography>
        </Box>
    );

    return <Tooltip title={tooltip}>{buttonContent}</Tooltip>;
}
